/**
 * Enum for Spa Migration Flag Ids
 * @readonly
 * @enum {name: {value: number}}
 */

export const SpaMigrationFlagIdsEnum = Object.freeze({
  myAttendance: 1,
  attendanceReport: 2,
  attendanceManagement: 3,
  certificateOfAttendance: 4,
  overtime: 5,
  officialBusiness: 6,
  leave: 7,
  shiftCenter: 8,
});
